export {getDecrypted} from './crypto-fragments';

export const getE2EE = state => state.e2ee;
